import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { getUserState } from '@carvana/core-auth';
import { isLocalEnvironment } from '../../../environment';
import ErrorToast from '../Toasts/ErrorToast';

type OwnProps = React.PropsWithChildren<unknown>;

const AuthGuard = ({ children }: OwnProps) => {
  const { pathname } = useLocation();
  const { isLoggedIn } = getUserState();

  useEffect(() => {
    if (!isLoggedIn) {
      ErrorToast(
        'You have been logged out due to inactivity; you are being redirected to sign back in.'
      );
      if (!isLocalEnvironment) {
        const returnUrl = encodeURIComponent(window.location.pathname);
        window.location.href = `/?openAccountModal=signin&returnUrl=${returnUrl}`;
      }
    }
  }, [pathname, isLoggedIn]);

  return isLoggedIn || isLocalEnvironment ? <>{children}</> : null;
};

export default AuthGuard;
